import React from "react";
import { withTranslation } from 'react-i18next';
import { withSnackbar } from 'notistack';
import {
    AppBar,
    Grid,
    Card,
    CardHeader,
    CardContent,
    CircularProgress,
    Fab,
    Typography,
    Tab,
    Tabs,
    Box
} from "@material-ui/core";
import PropTypes from 'prop-types';
import moment from 'moment'
import ArrowBack from '@material-ui/icons/ArrowBack';
import { getAssetAccountSummaries, getAssetGroupSummaries, getInventorySimple } from "../api/apiInventory";
import SelectClient from "common/components/custom/SelectClient";
import { getSpecificClients } from "views/clients/api/apiClients";
import SelectInventory from "common/components/custom/SelectInventory";
import CustomSelector from "common/components/custom/CustomSelector";
import GroupSummaryTab from "./tabs/GroupSummaryTab";
import AccountSummaryTab from "./tabs/AccountSummaryTab";
/* import 'chart.js/auto';
import { Line } from 'react-chartjs-2'; */

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <Typography
            component="div"
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box p={1}>{children}</Box>}
        </Typography>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

class InventorySummary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            selectedInventory: props.location.state && props.location.state.selectedInventory ? props.location.state.selectedInventory : null,
            groupSummaries: [],
            selectedClient: null,
            specificsClients: [],
            inventories: [],
            selectedFrom: props.location.state && props.location.state.selectedFrom ? moment(props.location.state.selectedFrom, 'DD-MM-YYYY') : new Date(new Date().getFullYear(), 0, 1),
            selectedTo: props.location.state && props.location.state.selectedTo ? moment(props.location.state.selectedTo, 'DD-MM-YYYY') : new Date(new Date().getFullYear() + 1, 0, 1),
            selectedRadioButton: props.location.state && props.location.state.selectedRadioButton ? props.location.state.selectedRadioButton : "currentYear",
            numberOfMonths: 0,
            selectedTab: 0,
            accountSummaries: []
        };
    }

    async componentDidMount() {
        this.getSpecificClients()
        this.state.selectedInventory && this.getAssetGroupSummaries(this.state.selectedInventory && this.state.selectedInventory.id)
        this.state.selectedInventory && this.getAssetAccountSummaries(this.state.selectedInventory && this.state.selectedInventory.id)
    }

    getAssetGroupSummaries = (inventoryId) => {
        let dateInterval = {
            depreciationFrom: moment(this.state.selectedFrom, 'DD-MM-YYYY').format("DD-MM-YYYY"),
            depreciationTo: moment(this.state.selectedTo, 'DD-MM-YYYY').format("DD-MM-YYYY")
        }
        getAssetGroupSummaries({ params: { inventoryId: inventoryId } }, dateInterval).then((response) => {
            this.monthDiff(new Date(this.state.selectedFrom), new Date(this.state.selectedTo))
            this.setState({
                groupSummaries: response.data.data.assetGroupSummaries,
                currentDepreciation: response.data.data.currentDepreciation,
                purchaseAmount: response.data.data.purchaseAmount,
                previousDepreciation: response.data.data.previousDepreciation,
                remainingDepreciation: response.data.data.remainingDepreciation,
                residualValue: response.data.data.residualValue,
                isLoading: false
            });

        }).catch(error => {
            this.props.enqueueSnackbar(this.props.t("something_went_wrong"), { variant: 'error' });
        });
    }

    getAssetAccountSummaries = (inventoryId) => {
        let requestBody = {
            depreciationFrom: moment(this.state.selectedFrom, 'DD-MM-YYYY').format("DD-MM-YYYY"),
            depreciationTo: moment(this.state.selectedTo, 'DD-MM-YYYY').format("DD-MM-YYYY")
        }
        getAssetAccountSummaries({ params: { inventoryId: inventoryId } }, requestBody).then((response) => {
            this.monthDiff(new Date(this.state.selectedFrom), new Date(this.state.selectedTo))
            this.setState({
                accountSummaries: response.data.data.assetAccountSummary,
                currentDepreciation: response.data.data.currentDepreciation,
                purchaseAmount: response.data.data.purchaseAmount,
                previousDepreciation: response.data.data.previousDepreciation,
                remainingDepreciation: response.data.data.remainingDepreciation,
                residualValue: response.data.data.residualValue,
                isLoading: false
            });

        }).catch(error => {
            this.props.enqueueSnackbar(this.props.t("something_went_wrong"), { variant: 'error' });
        });
    }

    getSpecificClients = () => {
        getSpecificClients().then((response) => {
            let selectedClient = response.data.data.length > 0 ? response.data.data[0] : null
            this.setState({ specificsClients: response.data.data, selectedClient: selectedClient, isLoading: false }, selectedClient ? this.getInventorySimple(selectedClient.id) : null);
        }).catch(error => {
            this.props.enqueueSnackbar(this.props.t("something_went_wrong"), { variant: 'error' });
        });
    }

    getInventorySimple = (selectedClient) => {
        getInventorySimple(selectedClient).then((response) => {
            const firstDayInCurrentYear = moment().startOf('year');
            const firstDayInNextYear = moment().endOf('year').add(1, 'days');
            this.monthDiff(firstDayInCurrentYear, firstDayInNextYear)
            this.setState({
                inventories: response.data.data,
                selectedTo: this.state.selectedTo !== null ? this.state.selectedTo : firstDayInNextYear,
                selectedFrom: this.state.selectedFrom !== null ? this.state.selectedFrom : firstDayInCurrentYear
            });
        }).catch(error => {
            this.props.enqueueSnackbar(this.props.t("something_went_wrong"), { variant: 'error' });
        });
    }

    monthDiff = (dateFrom, dateTo) => {
        if (dateFrom === null && dateTo === null) {
            this.setState({
                numberOfMonths: 0,
                groupSummaries: [],
                accountSummaries: []
            })
        } else {
            let monthsDiff = moment(dateTo).diff(moment(dateFrom), 'months', true);
            if (isNaN(monthsDiff)) {
                this.setState({ numberOfMonths: 0 })
            }
            this.setState({ numberOfMonths: Math.floor(monthsDiff) })
        }
    }

    handleChangeClient = (client) => {
        if (client !== null) {
            this.setState({ selectedClient: client }, () => this.getInventorySimple(client.id))
        } else {
            this.setState({ selectedClient: null, selectedInventory: null, groupSummaries: [], accountSummaries: [] })
        }
    }

    handleChangeInventory = (inventory) => {
        if (inventory !== null) {
            this.setState({ selectedInventory: inventory }, () => this.state.selectedTab === 0 ? this.getAssetGroupSummaries(this.state.selectedInventory.id) : this.getAssetAccountSummaries(this.state.selectedInventory.id))
        } else {
            this.setState({ selectedInventory: null, groupSummaries: [], accountSummaries: [] })
        }
    }

    handleChangeFromDate = (date) => {
        if (date !== null && date._isValid) {
            if (moment(date).isAfter('1900-01-01', 'year') && moment(date).isBefore('2100-01-01', 'year')) {
                this.setState({ selectedFrom: date }, () => this.state.selectedTo !== null && this.state.selectedTab === 0 ? this.getAssetGroupSummaries(this.state.selectedInventory.id) : this.state.selectedTo !== null && this.state.selectedTab === 1 ? this.getAssetAccountSummaries(this.state.selectedInventory.id) : null)
            } else { this.setState({ selectedFrom: date }) }
        }
    }

    handleChangeToDate = (date) => {
        if (date !== null && date._isValid) {
            if (moment(date).isAfter('1900-01-01', 'year') && moment(date).isBefore('2100-01-01', 'year')) {
                this.setState({ selectedTo: date }, () => this.state.selectedFrom !== null && this.state.selectedTab === 0 ? this.getAssetGroupSummaries(this.state.selectedInventory.id) : this.state.selectedFrom !== null && this.state.selectedTab === 1 ? this.getAssetAccountSummaries(this.state.selectedInventory.id) : null)
            } else { this.setState({ selectedTo: date }) }
        }
    }

    changeDates = (selectedFrom, selectedTo, selectedRadioButton) => {
        if (selectedFrom !== null && selectedTo !== null) {
            this.setState({
                selectedFrom: selectedFrom,
                selectedTo: selectedTo,
                selectedRadioButton: selectedRadioButton
            }, () => this.state.selectedTab === 0 ? this.getAssetGroupSummaries(this.state.selectedInventory.id) : this.state.selectedTab === 1 ? this.getAssetAccountSummaries(this.state.selectedInventory.id) : null)
        } else {
            this.setState({
                selectedFrom: selectedFrom,
                selectedTo: selectedTo,
                selectedRadioButton: selectedRadioButton
            })
        }
    }

    handleChangeTab = (event, value) => {
        let { selectedFrom, selectedTo } = this.state;
        this.setState({ selectedTab: value });
        if (selectedFrom !== null && selectedTo !== null) {
            value === 0 ? this.getAssetGroupSummaries(this.state.selectedInventory.id) : this.getAssetAccountSummaries(this.state.selectedInventory.id)
        }
    }

    render() {

        let { isLoading, groupSummaries, specificsClients, selectedClient, inventories, selectedInventory, selectedFrom, selectedTo, selectedTab, accountSummaries } = this.state;

        if (isLoading) {
            return (
                <div className="loading-position">
                    <CircularProgress className="spinner" color="primary" />
                </div>
            )
        }

        /* const data = {
            labels: [this.props.t("previous_depreciation"), this.props.t("amount_time_period"), this.props.t("amount_after_period"), this.props.t("purchase_amount"), this.props.t("residual_value")],
            datasets: [
                {
                    label: 'test',
                    data: [this.state.previousDepreciation, this.state.currentDepreciation, this.state.remainingDepreciation, this.state.purchaseAmount, this.state.residualValue],
                    backgroundColor: "red",
                    borderColor: "red",
                    borderWidth: 2,
                }, {
                    label: 'test1',
                    data: [this.state.remainingDepreciation, this.state.purchaseAmount, this.state.residualValue, this.state.previousDepreciation, this.state.currentDepreciation],
                    backgroundColor: "green",
                    borderColor: "green",
                    borderWidth: 2,
                }
            ],
        };*/

        return <Grid container direction="row" spacing={2}>
            <Grid item container direction="column" xs={12} sm={12} md={12} lg={12} xl={12}>
                <CardHeader
                    style={{ height: '62px' }}
                    title={<Typography variant={"h6"}>{this.props.t("inventory_summary")}</Typography>}
                    avatar={
                        <Fab
                            size="small"
                            color="secondary"
                            onClick={() => this.props.history.goBack()}>
                            <ArrowBack />
                        </Fab>
                    } />
                <Card>
                    <CardContent>
                        <Grid container direction="row" spacing={2}>
                            <Grid item container direction="column" xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Grid container direction="row" spacing={2}>
                                    <Grid item container direction="column" xs={3} sm={3} md={3} lg={3} xl={3}>
                                        <SelectClient
                                            specificsClients={specificsClients}
                                            selectedClient={selectedClient}
                                            handleChange={this.handleChangeClient}
                                        />
                                    </Grid>
                                    {selectedClient !== null && <Grid item container direction="column" xs={3} sm={3} md={3} lg={4} xl={4}>
                                        <Grid item container>
                                            <SelectInventory
                                                inventories={inventories}
                                                selectedInventory={selectedInventory}
                                                handleChange={this.handleChangeInventory}
                                            />
                                        </Grid>
                                    </Grid>}
                                    <Grid item container direction="column" xs={3} sm={2} md={2} lg={1} xl={2}>
                                        <Grid item container>
                                        </Grid>
                                    </Grid>
                                    <CustomSelector
                                        selectedInventory={selectedInventory}
                                        selectedTo={selectedTo}
                                        selectedFrom={selectedFrom}
                                        handleChangeToDate={this.handleChangeToDate}
                                        handleChangeFromDate={this.handleChangeFromDate}
                                        numberOfMonths={this.state.numberOfMonths}
                                        selectedRadioButton={this.state.selectedRadioButton}
                                        changeDates={(selectedFrom, selectedTo, selectedRadioButton) => this.changeDates(selectedFrom, selectedTo, selectedRadioButton)}
                                        monthDiff={(dateFrom, dateTo) => this.monthDiff(dateFrom, dateTo)}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        {selectedInventory !== null && <Grid container direction="row" spacing={2}>
                            <Grid item container direction="column" xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Grid item container>
                                    <AppBar position="static" color="default">
                                        <Tabs value={selectedTab} indicatorColor="secondary" onChange={this.handleChangeTab}>
                                            <Tab className={selectedTab === 0 ? "custom-tab-border" : null} label={this.props.t("group_summary")} {...a11yProps(0)} />
                                            <Tab className={selectedTab === 1 ? "custom-tab-border" : null} label={this.props.t("account_summary")} {...a11yProps(1)} />
                                        </Tabs>
                                    </AppBar>
                                </Grid>
                                <Grid item container className="MuiBox-rmp">
                                    <TabPanel value={selectedTab} index={0} style={{ width: "100%" }}>
                                        <GroupSummaryTab
                                            groupSummaries={groupSummaries}
                                            previousDepreciation={this.state.previousDepreciation}
                                            currentDepreciation={this.state.currentDepreciation}
                                            remainingDepreciation={this.state.remainingDepreciation}
                                            purchaseAmount={this.state.purchaseAmount}
                                            residualValue={this.state.residualValue}
                                            selectedInventory={selectedInventory}
                                            selectedClient={selectedClient}
                                            selectedFrom={selectedFrom}
                                            selectedTo={selectedTo}
                                            selectedRadioButton={this.state.selectedRadioButton}
                                            history={this.props.history}
                                        />
                                    </TabPanel>
                                    <TabPanel value={selectedTab} index={1} style={{ width: "100%" }}>
                                        <AccountSummaryTab
                                            accountSummaries={accountSummaries}
                                            previousDepreciation={this.state.previousDepreciation}
                                            currentDepreciation={this.state.currentDepreciation}
                                            remainingDepreciation={this.state.remainingDepreciation}
                                            purchaseAmount={this.state.purchaseAmount}
                                            residualValue={this.state.residualValue}
                                            selectedInventory={selectedInventory}
                                            selectedClient={selectedClient}
                                            selectedFrom={selectedFrom}
                                            selectedTo={selectedTo}
                                            selectedRadioButton={this.state.selectedRadioButton}
                                            history={this.props.history}
                                        />
                                    </TabPanel>
                                </Grid>
                            </Grid>
                        </Grid>}
                    </CardContent>
                </Card>
            </Grid>
        </Grid>
    }
}

export default withSnackbar(withTranslation()(InventorySummary))